import React from "react";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import { toastr } from "react-redux-toastr";
import { useAuth0 } from "@auth0/auth0-react";
import "react-datepicker/dist/react-datepicker.css";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@material-ui/core";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { getDateFormatForDatePicket } from "helper/dateFormat";
// component
import MyButton from "components/MyButton/index";
import PastoralService from "Lib/API/PastoralApi/index";

function convertUTCToLocalDate(date) {
  if (!date) {
    return date;
  }
  date = new Date(date);
  date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  return date;
}

function convertLocalToUTCDate(date, name, form) {
  if (!date) {
    return date;
  }
  date = new Date(date);
  date = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
  form.setFieldValue(name, date);
  return date;
}

// Custom Formik Field Wrapper for DatePicker
const DatePickerField = ({ field, form, dateFormate, ...props }) => (
  <DatePicker
    {...props}
    selected={convertUTCToLocalDate(field.value)}
    dateFormat={dateFormate ?? "mm/dd/yyyy"}
    // onChange={(date) => form.setFieldValue(field.name, date)}
    onChange={(date) => {
      convertLocalToUTCDate(date, field.name, form);
    }}
    className="form-control mt-2"
    portalId="date-picker-portal"
    // localFormat="true"
    popperModifiers={[
      {
        name: "zIndex",
        enabled: true,
        phase: "write",
        fn: ({ state }) => {
          state.elements.popper.style.zIndex = "999999999";
        },
      },
    ]}
  />
);

const validationSchema = Yup.object().shape({
  eventDate: Yup.date().required("Event date is required"),
});

const EditEventDateModal = ({
  open,
  initialDate,
  onClose,
  eventId,
  setCallFeedsAgain,
  refetchEventCallback,
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const dateFormate = getDateFormatForDatePicket();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit Event Date</DialogTitle>

      <Formik
        initialValues={{ eventDate: initialDate }}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          const data = { date: values?.eventDate };

          try {
            const token = await getAccessTokenSilently();
            await PastoralService.updateEvent({
              data,
              token,
              eventId: eventId,
            });
            toastr.success("Success", `Event Date Changed Successfully!`);
            setCallFeedsAgain();
            refetchEventCallback();
            onClose();
          } catch (error) {
            toastr.error(
              "Error",
              error?.data?.message || "Something went wrong!"
            );
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <DialogContent>
              <Field
                name="eventDate"
                dateFormate={dateFormate}
                component={DatePickerField}
              />
              <ErrorMessage
                name="eventDate"
                component="div"
                className="text-danger mt-1 fs-12"
              />
            </DialogContent>

            <DialogActions
              style={{ marginTop: 10, paddingRight: 23, marginBottom: 15 }}
            >
              <MyButton
                type="secondary"
                content="Close"
                onClick={onClose}
                disabled={isSubmitting}
              />
              <MyButton
                type="primary"
                content={
                  isSubmitting ? (
                    <CircularProgress size={18} style={{ color: "#fff" }} />
                  ) : (
                    "Save"
                  )
                }
                variant="outlined"
                disabled={isSubmitting}
                style={{
                  minWidth: 103,
                  height: 45,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditEventDateModal;
